import {Injectable} from '@angular/core';
import {AuthService} from '../../../../../firebase/src/lib/services/auth.service';

@Injectable({
    providedIn: 'root'
})
export class AiAssistantService {

    constructor(
        public auth: AuthService
    ) {
    }

    get isAiSubscription() {
        const state = localStorage.getItem('user_state');
        const data = state && typeof state !== 'undefined' ? JSON.parse(state) : false;
        return data ?
            data?.subscription?.features?.find((el: any) => el === 'AI-assistant')?.length > 0
            || data?.features?.find((el: any) => el === 'AI-assistant')?.length > 0
            : false;
    }

    get isSubscription() {
        const state = localStorage.getItem('user_state');
        const data = state && typeof state !== 'undefined' ? JSON.parse(state) : false;

        return data && data?.subscription && data.subscription?.activated;
    }
}
